// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailAttention_root__17y4k","marketplaceStroke":"IconEmailAttention_marketplaceStroke__3mx4a","attentionStroke":"IconEmailAttention_attentionStroke__2Qh0g"};